// src/context/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { http, setAuthToken } from '../lib/api';

const AuthContext = createContext(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [boot, setBoot] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const tok = localStorage.getItem('token');
      if (tok) {
        try {
          setAuthToken(tok);
          const r = await http.get('/auth/me');
          const userData = r.data;
          setUser(userData);
          // Actualizar datos en localStorage
          localStorage.setItem('user', JSON.stringify(userData));
        } catch (error) {
          console.error('Error al inicializar la autenticación:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setAuthToken(null);
          setUser(null);
        }
      }
      setBoot(false);
    };

    initAuth();
  }, []);

  const login = async (username, password) => {
    try {
      console.log('Intentando login con:', username);
  const r = await http.post('/auth/login', { username, password });
      console.log('Respuesta del servidor:', r.data);
      
      const { access_token, user: u } = r.data;
      if (!access_token || !u) {
        console.error('Falta token o datos de usuario en la respuesta');
        throw new Error('Respuesta inválida del servidor');
      }
      
      setAuthToken(access_token);
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(u));
      setUser(u);
      
      // Verificar que el token se guardó correctamente
      const savedToken = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');
      console.log('Token guardado:', savedToken ? 'Sí' : 'No');
      console.log('Usuario guardado:', savedUser ? 'Sí' : 'No');
      
      return { ok: true };
    } catch (e) {
      console.error('Login error', e);
      console.error('Detalles del error:', e.response?.data);
      
      if (e.response?.status === 401) {
        return { ok: false, message: 'Usuario o contraseña incorrectos' };
      }
      if (e.response?.data?.detail) {
        return { ok: false, message: e.response.data.detail };
      }
      if (e.message === 'Network Error') {
        return { ok: false, message: 'Error de conexión con el servidor' };
      }
      return { ok: false, message: 'Error de conexión' };
    }
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, boot }}>
      {children}
    </AuthContext.Provider>
  );
}
